<template>
    <v-dialog 
        :value="filterPopup"
        @input="toggleFilterPopup()" 
        max-width="800px"
        scrollable
        :fullscreen="$vuetify.breakpoint.smAndDown"
        :transition="$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : null"
    >
        <v-card>
            <v-app-bar
                height="50" 
                width="100%" 
                class="pa-0"
                elevate-on-scroll
                scroll-target="#filter-dialog"
            >
                <v-container fluid class="d-flex justify-space-between">
                    <v-container class="d-flex justify-space-around">
                        <v-toolbar-title class="font-weight-bold">
                            {{ $t("sidebar.section.filters") }}
                        </v-toolbar-title>
                    </v-container>

                    <v-btn 
                        icon
                        large
                        @click.prevent="toggleFilterPopup()"
                        :ripple="false"
                    >
                        <v-icon color="black">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-container>
            </v-app-bar>	
            <v-sheet
                id="filter-dialog"
                class="overflow-y-auto"
            >
                <v-divider/>
                <div class="px-4 pb-4">
                    <v-container class="sidebar-content pa-0">
                        <!-- PLOT SEARCH -->
                        <div class="search-block">
                            <autocomplete
                                id="gtm-input-plotsearch"
                                class="habiteo-body-2"
                                :search="search"
                                ref="autocomplete"
                                :placeholder="$t('sidebar.searchBar')"
                                auto-select
                                @submit="searchSubmit"
                            />
                            <v-icon
                                v-if="inputSearch == ''"
                                class="btn-search"
                            >
                                icon-glass-search-bar
                            </v-icon>
                            <v-icon
                                v-else
                                class="btn-search"
                                @click="resetSearch()"
                            >
                                icon-delete-search-bar
                            </v-icon>
                        </div>

                        <!-- FAVORITES -->
                        <div class="pt-4 px-2">
                            <v-row class="d-flex align-center">
                                <v-col cols="12">
                                    <v-btn
                                        id="gtm-filter-favorite"
                                        class="pa-0 justify-start"
                                        text
                                        block
                                        :ripple="false"
                                        :elevation="0"
                                        @click.prevent="filterFavorite();"
                                    >
                                        <div class="d-flex pa-0">
                                            <v-icon
                                                class="pa-0"
                                                :class="{ 'active active-heart': data.filters.isFavorite }"
                                            >
                                                {{ data.filters.isFavorite ? 'icon-favorite' : 'icon-empty-favorite grey-text text-darken-1'}}
                                            </v-icon>
                                            <div class="pa-2">
                                                <div class="habiteo-body-2 text-left favorite font-weight-bold text-none dark-text">
                                                    {{ $t('favorite.wishlist') }} ({{ favoritePlotCounter }})
                                                </div>
                                                <div class="legend text-none grey-text text-darken-1">
                                                    {{ $t("favorite.info") }}
                                                </div>
                                            </div>
                                        </div>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>

                        <!-- TYPOLOGIES -->
                        <CheckboxFilter
                            v-if="showTypologiesCheckbox"
                            key="typologies"
                            filterType="typology"
                            :filterData="data.filters.typologies"
                            @filter-method="filterByTypology"
                        />

                        <!-- PRICES -->
                        <SliderFilter
                            v-if="showPriceSlider"
                            :key="'price'"
                            :sliderType="data.program.investType === 'rent' ? 'rent' : 'price'"
                            :min="data.filters.priceInterval.min"
                            :max="data.filters.priceInterval.max"
                            :userFilter="data.filters.userPriceInterval"
                            @filter-method="filterByPrice"
                        />

                        <!-- AREA -->
                        <SliderFilter
                            v-if="showAreaSlider"
                            key="area"
                            sliderType="area"
                            :areaUnit="data.areaUnit"
                            :min="data.filters.areaInterval[data.areaUnit].min"
                            :max="data.filters.areaInterval[data.areaUnit].max"
                            :userFilter="data.filters.userAreaInterval"
                            @filter-method="filterByArea"
                        />

                        <!-- LEVELS -->
                        <CheckboxFilter
                            v-if="useFloorFilter"
                            key="floors"
                            filterType="floor"
                            :filterData="data.filters.floors"
                            @filter-method="filterByFloor"
                        />

                        <!-- AVAILABILITIES -->
                        <CheckboxFilter
                            v-if="showAvailabilitiesCheckbox"
                            key="availabilities"
                            filterType="availability"
                            :filterData="data.filters.availabilities"
                            @filter-method="filterByAvailability"
                        />

                        <!-- TAGS -->
                        <CheckboxFilter
                            v-if="showTagsCheckbox"
                            key="tags"
                            filterType="tag"
                            :filterData="data.filters.tags"
                            @filter-method="filterTag"
                        />
                    </v-container>
                </div>
                <v-divider/>
                <v-card-actions class="py-6 px-4">
                    <ButtonText @reset-method="resetFilters" />
                    <v-spacer/>
                    <v-btn
                        @click.prevent="applyFilters()"
                        depressed
                        class="text-none" 
                        color="success"
                    >
                        {{ $t('map.showResult') }}
                    </v-btn>
            </v-card-actions>
            </v-sheet>	
        </v-card>
    </v-dialog>
</template>

<script>
    import { EventBus } from "@/event-bus";
    import ButtonText from "@/components/filters/ButtonText";
    import _ from "lodash";
    import { mapGetters, mapActions } from 'vuex';
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import CheckboxFilter from '@/components/filters/CheckboxFilter';
    import SliderFilter from '@/components/filters/SliderFilter';
    import RadioButton from '@/components/filters/RadioButton';
    import ResetFiltersButton from '@/components/filters/ResetFiltersButton';

    export default {
        name: "CutawayFiltersPopup",
        props: [
            "data",
            "filterPopup"
        ],
        data() {
            return {
                defaultFilters: null, 
                inputSearch: "",
                clickedTracking: false,
                plotFavList: [],
                lastWidget: null,
                
            };
        },
        components: {
            ButtonText ,
            Autocomplete,
            CheckboxFilter,
            SliderFilter,
            RadioButton,
            ResetFiltersButton
        },
        mounted() {
            this.defaultFilters = _.cloneDeep(this.$props.data.filters);
            this.widget = this.$props.data.type === 'cutaway' ? this.widget : 'plot-grid';
            if (this.isLocalstorageAvailable)
                this.favoriteList = localStorage.getItem(this.favoriteKey) ? JSON.parse(localStorage.getItem(this.favoriteKey)) : [];

            if (this.hasSharedFavlist)
                this.filterFavorite();

            EventBus.$on('setCutawayWidget', widget => this.$props.data.type = widget);

            EventBus.$on('updatePlotFavorites', favoriteList => {
                this.favoriteList = favoriteList;
            });

            EventBus.$on('updateFloor', floor => this.getCurrentFloor(floor));

            EventBus.$on('switchSidebar', widget => {
                this.widget = widget;
                this.$props.data.type = widget;
            });
        },
        computed:{
            ...mapGetters([
                'isLocalstorageAvailable',
                'isReviewUse',
                'protocol'
            ]),
            favoriteKey() {
                return `favorite-${this.programUuid}`;
            },
            programUuid() {
                return this.$props.data ? this.$props.data.program.id : null;
            },
            useFloorFilter() {
                return this.$props.data.filters.floors && this.$props.data.filters.floors.length > 1 && this.$props.data.type === 'plot-grid';
            },
            showTypologiesCheckbox() {
                return this.$props.data.filters.typologies && Object.keys(this.$props.data.filters.typologies).length > 0;
            },
            showAvailabilitiesCheckbox() {
               return this.$props.data.filters.availabilities && Object.keys(this.$props.data.filters.availabilities).length > 0;
            },
            showTagsCheckbox() {
                return this.$props.data.filters.tags && this.$props.data.filters.tags.length > 0;
            },
            showPriceSlider() {
                return this.$props.data.filters.priceInterval && this.$props.data.filters.priceInterval.min !== null && (this.$props.data.filters.priceInterval.max !== null && this.$props.data.filters.priceInterval.max !== 0);
            },
            showAreaSlider() {
                return this.$props.data.filters.areaInterval[this.$props.data.areaUnit] && this.$props.data.filters.areaInterval[this.$props.data.areaUnit].min !== null && (this.$props.data.filters.areaInterval[this.$props.data.areaUnit].max !== null && this.$props.data.filters.areaInterval[this.$props.data.areaUnit].max !== 0);
            },
            hasSharedFavlist() {
                return this.$route.query.favlist ? true : false;
            },
            favoriteList: {
                get() {
                    return this.plotFavList;
                },
                set(newValue) {
                    localStorage.setItem(this.favoriteKey, JSON.stringify(newValue));
                    this.plotFavList = JSON.parse(localStorage.getItem(this.favoriteKey));
                }
            },
            favoritePlotCounter() {
                return this.favoriteList.length;
            },
            apiUrl() {
                return 'https://' + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        
        methods: {
            toggleFilterPopup() {
                this.$emit("toogle-filter-popup");
            },
            applyFilters() {
                if (this.$props.data.lotView === 'both') {
                    EventBus.$emit('3d_FilterHotspot');
                    EventBus.$emit('plotgrid_FilterHotspot', this.$props.data.filters);
                } else if (this.$props.data.lotView === '3d')
                    EventBus.$emit('3d_FilterHotspot');
                else
                    EventBus.$emit('plotgrid_FilterHotspot', this.$props.data.filters);
                this.toggleFilterPopup();
            }, 
            ...mapActions('widget', [
                'setDisplayFavorite'
            ]),
            resetFilters() {
                this.$props.data.filters = _.cloneDeep(this.defaultFilters);
                this.resetSliders();
                this.resetSearch();
                EventBus.$emit('updateSidebar', this.$props.data, false);
            },
            resetSliders() {
                EventBus.$emit('resetSliders');
            },
            filterByPrice(min, max) {
                if (!this.$props.data.filters.userPriceInterval)
                    this.$props.data.filters.userPriceInterval = {min: 0, max: 0};

                this.$props.data.filters.userPriceInterval.min = min;
                this.$props.data.filters.userPriceInterval.max = max;
                this.resetSearch();
                this.trackingEventSearching();
            },
            filterByTypology(typology) {
                typology.active = !typology.active;
                this.resetSearch();
                this.trackingEventSearching();
            },
            filterByArea(min, max) {
                if (!this.$props.data.filters.userAreaInterval)
                    this.$props.data.filters.userAreaInterval = {min: 0, max: 0};

                this.$props.data.filters.userAreaInterval.min = min;
                this.$props.data.filters.userAreaInterval.max = max;
                this.resetSearch();
                this.trackingEventSearching();
            },
            selectFloor(floor) {
                this.getCurrentFloor(floor);
                this.resetSearch();
            },
            filterByFloor(floor) {
                this.$set(floor, 'active', !floor.active ? true : false);
                this.resetSearch();
                this.trackingEventSearching();
            },
            getCurrentFloor(floor){
                this.$props.data.floors.filter(el => el.active).forEach(el => el.active = false);
                this.$props.data.floors.filter(el => el.id === floor.id)[0].active = true;
                EventBus.$emit('updateCutawayData', floor);
            },
            filterFavorite() {
                this.$props.data.filters.isFavorite = !this.$props.data.filters.isFavorite;
                this.$props.data.filters.enableFavorite = [];
                if (this.$props.data.filters.isFavorite) {
                    this.$props.data.floors.forEach(floor => {
                        floor.hotspots.forEach(hotspot => {
                            if (hotspot.link) {
                                let url = new URL(hotspot.link);
                                let plotId = url.searchParams.get('id');
                                if (plotId !== null && this.favoriteList.includes(plotId))
                                    if (!this.$props.data.filters.enableFavorite.includes(hotspot.name))
                                        this.$props.data.filters.enableFavorite.push(hotspot.name);
                            }
                        });
                    });
                    this.setDisplayFavorite(true);

                    if (this.$props.data.type === 'cutaway' && this.$props.data.lotView === 'both') {
                        this.toggleWidget('plot-grid');
                        this.lastWidget = 'cutaway';
                    }
                } else {
                    this.$props.data.floors.forEach(floor => {
                        floor.hotspots.forEach(hotspot => {
                            if (!this.$props.data.filters.enableFavorite.includes(hotspot.name))
                                this.$props.data.filters.enableFavorite.push(hotspot.name);
                        });
                    });
                    if (this.lastWidget) {
                        this.toggleWidget(this.lastWidget);
                        this.lastWidget = null;
                    }

                    this.setDisplayFavorite(false);
                }
                this.resetSearch();
                EventBus.$emit('updateSidebar', this.data, false);
                this.trackingEventSearching();
            },
            toggleWidget(widget) {
                EventBus.$emit('updateLoadedWidgets', {
                    id: widget,
                    link: this.apiUrl  + '/request-data/cutaway-view' + window.location.search,
                    active: true,
                    widgetType: widget
                });
                EventBus.$emit('switchSidebar', widget);
            },
            filterByAvailability(availability) {
                availability.active = !availability.active;
                this.resetSearch();
                this.trackingEventSearching();
                EventBus.$emit('updateSidebar', this.data, false);
            },
            trackingEventSearching() {
                let event = "searching";
                let trackingData = this.$props.data.tracking;
                if (!this.clickedTracking) {
                    this.clickedTracking = true;
                    EventBus.$emit('trackingEvent', trackingData, event);
                    setTimeout(() => {
                        this.clickedTracking = false;
                    }, 10000);
                }
            },
            filterTag(currentTag) {
                this.$props.data.filters.tags.filter(tag => tag.id === currentTag.id)[0].active = !currentTag.active;
                this.resetSearch();
                EventBus.$emit('updateSidebar', this.data, false);
            },
            resetSearch() {
                this.$props.data.filters.searchValue = null;
                this.inputSearch = '';
                this.$refs.autocomplete.value = '';
    
            },
            search(input) {
                let hotspotList = [];
                this.inputSearch = input;
                if (input.length < 1)
                    return [];

                this.$props.data.floors.forEach(floor => {
                    floor.hotspots.forEach(hotspot => {
                        if (hotspot.name !== null && !hotspotList.includes(hotspot.name))
                            hotspotList.push(hotspot.name);
                    });
                });
                return hotspotList.filter(hotspot => {
                    return hotspot.toLowerCase().includes(input.toLowerCase());
                }).slice(0, 10);
            },
            searchSubmit() {
                this.$props.data.floors.forEach(floor => {
                    floor.hotspots.forEach(hotspot => {
                        if (hotspot.name === this.$refs.autocomplete.value){
                            this.getCurrentFloor(floor);
                            this.$props.data.filters.searchValue = this.$refs.autocomplete.value
                        }
                    });
                });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/layout/alternative/cutaway/components/CutawayFiltersPopup.vue